<template>
  <modal name="jigen-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeJigenDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/jigen_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>
          <br />
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">遷移先のサイトで働きたい</p>
        <p style="font-size: 140%;">アルバイトを探そう！</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して求人受取や<br>会員登録を希望する
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <p style="font-size: 140%;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して求人受取や<br>会員登録を希望する</el-checkbox>
        </p>
        <br />
      </div>
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-jigen-consult-jigendialog');">希望する</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeJigenDialog();">送信しました</el-button>
        <br />
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <br />
        <br />
        <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
        <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
      </div>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
          style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3uT6SV6', '_blank');"><span>無料で質問する</span></button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
    <div class="setting" v-elseif="permissionType == 2">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">もしよかったら副業などを探すために<br>アルバイト求人サイトにも登録してみよう！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/jigen_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>
          <br />
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して求人受取や<br>会員登録を希望する
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <p style="font-size: 140%;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して求人受取や<br>会員登録を希望する</el-checkbox>
        </p>
        <br />
      </div>
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-jigen2-consult-jigendialog');">副業などを希望する</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeJigenDialog();">送信しました</el-button>
        <br />
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <br />
        <br />
        <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
        <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
      </div>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
          style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3uT6SV6', '_blank');"><span>無料で質問する</span></button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      clientId: 'jigen_ex',
      isAgree: true,
      medleyID: 1
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openJigenDialog: function (id, html, permissionType, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.permissionType = permissionType
      this.$modal.show('jigen-dialog')
      this.clearLocalStorageConfirmVisible = false

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'jigen_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeJigenDialog: function () {
      this.$modal.hide('jigen-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'jigen_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult2: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'jigen_dialog')
      formData.append('client_id', 'jigen_ex2')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-jigen-consult-jigendialog', this.sendJigenConsult)
    this.$eventHub.$on('send-jigen2-consult-jigendialog', this.sendJigenConsult2)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openJigenDialog = wrapMittPopupHandler(this, 'openJigenDialog')
    this.$emitter.on('open-jigen-dialog', this._mittGVPopup_openJigenDialog)
    this.$eventHub.$on('popstate', this.closeJigenDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-jigen-consult-jigendialog', this.sendJigenConsult)
    this.$eventHub.$off('send-jigen2-consult-jigendialog', this.sendJigenConsult2)
    this.$emitter.off('open-jigen-dialog', this._mittGVPopup_openJigenDialog)
    this.$eventHub.$off('popstate', this.closeJigenDialog)
  }
}
</script>
